import { onMount } from 'cdui-js';
import { trackAccountOpenSubmit } from '../../../../../analytics';
import { saveUserInfo, submitApply } from '../../../../../api/open-account';
import { LastNextBtns } from '../components/LastNextBtns';
import { lastProcess, nextProcess, pState, setFormValidateFunc } from '../store';
import { completeKycSubmitStep } from '../kycAnalytics';
import { DiFiInput } from '../../../../../components/DiFi/DiFiInput';
import { showToast } from '../../../components/Toast';
import i18n from '../../../../../i18n';

export const ContactInfos = () => {
  const validateFunc = async () => {
    if (!String(pState.offline.name || '').trim() || !String(pState.offline.phone || '').trim()) {
      showToast(i18n.OpenProgress.Offline.ToastContactRequired);
      return false;
    }
    return true;
  };

  onMount(() => {
    setFormValidateFunc({ callback: validateFunc });
  });

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="font-s-L color-D">{i18n.OpenProgress.Offline.ContactTitle}</div>
      <div class="margin-t-XL">{i18n.OpenProgress.Offline.YourName}</div>
      <div>
        <DiFiInput
          shellClass="f-input-2"
          inputKind="text"
          maxLength={80}
          placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
          value={pState.offline.name}
          onUpdateValue={(v) => (pState.offline.name = v)}
        />
      </div>

      <div class="margin-t-XL">{i18n.OpenProgress.Offline.Phone}</div>
      <div>
        <DiFiInput
          shellClass="f-input-2"
          type="tel"
          inputKind="tel"
          maxLength={50}
          placeholder={i18n.OpenProgress.Common.PlaceholderEnter}
          value={pState.offline.phone}
          onUpdateValue={(v) => (pState.offline.phone = v)}
        />
      </div>

      <LastNextBtns
        last={() => {
          lastProcess();
        }}
        next={async () => {
          await saveUserInfo({ progress: 4, fullName: pState.offline.name, phone: pState.offline.phone });
          try {
            await submitApply({ id: pState.id, progress: 20 });
            trackAccountOpenSubmit();
            completeKycSubmitStep(true);
          } catch {
            trackAccountOpenSubmit();
            completeKycSubmitStep(false);
            return;
          }
          if (pState.auditInfo) {
            pState.auditInfo.status = 'SUBMITTED';
          }
          nextProcess();
        }}
      />
    </div>
  );
};
